<div class="main-Content">
    <table class="mat-elevation-z8">
        <tr>
          <td colspan="12" style="background-color: rgb(249, 216, 216); color: Red; text-align: center; height: 50px;width: 10000px !important;">Under Construction!</td>
        </tr>
    </table>     
</div>